import {loadScript, observe} from "../utils/scripts";

export const loginSuccess = ({session, redirectTo}: {session: string; redirectTo?: string}) => {
  window.localStorage.setItem("session", session);
  window.location.replace(redirectTo || "/");
};

observe("[data-login-success]", (el, added) => {
  if (added) {
    const session = el.getAttribute("data-session");
    const redirectTo = el.getAttribute("data-redirect-to");
    if (session) {
      loginSuccess({session, redirectTo: redirectTo ?? undefined});
    }
  }
});

export const loginWithGoogle = ({el, clientId}: {el: Element; clientId: string}) => {
  loadScript("https://accounts.google.com/gsi/client", () => {
    const callback = (payload: any) => {
      const token = payload.credential;
      // @ts-expect-error HTMX
      window.htmx.trigger(el, "login-with-google", {token});
    };

    // @ts-expect-error Google
    google.accounts.id.initialize({
      client_id: clientId,
      callback,
    });

    // @ts-expect-error Google
    google.accounts.id.renderButton(el, {theme: "filled_blue", size: "large"});
  });
};

observe("[data-login-with-google]", (el, added) => {
  if (added) {
    const clientId = el.getAttribute("data-client-id");
    if (clientId) {
      loginWithGoogle({el, clientId});
    }
  }
});

export const logout = () => {
  window.localStorage.removeItem("session");
  window.location.replace("/");
};

observe("[data-logout]", (_, added) => {
  if (added) {
    logout();
  }
});
